import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { BrowserStorageHelper } from '@core/helpers';
import { MixpanelService } from '@core/services';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-unauthorized-page',
    templateUrl: './unauthorized-page.component.html',
    styleUrls: ['./unauthorized-page.component.scss'],
    standalone: true,
    imports: [ButtonModule, TranslateModule, NgOptimizedImage],
})
export class UnauthorizedPageComponent {
    constructor(
        private auth0: AuthService,
        private mixpanelService: MixpanelService
    ) {}

    openChat(): void {
        // @ts-ignore
        window['happyFoxChat'].showWidget();
        // @ts-ignore
        window['happyFoxChat'].expandChatbox();
    }

    logout(): void {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;
        BrowserStorageHelper.killSession();

        this.auth0.logout({
            openUrl(_url) {
                window.location.replace(url);
            },
        });
    }

    logTransnetyxTag(): void {
        this.mixpanelService.logEvent('retest-setup-transnetyx-mail-tag');
    }
}
